/**
 * Sudan Crops Configuration
 * What farmers actually use - jawal/quintar/kg
 */

export const SUDAN_CROPS = [
  // Gedaref / Eastern belt staples
  { slug: "sesame", nameAr: "سمسم", nameEn: "Sesame", defaultUnit: "jawal", altUnits: ["quintar", "kg"], priority: 1, icon: "🌾" },
  { slug: "sorghum", nameAr: "ذرة", nameEn: "Sorghum", defaultUnit: "quintar", altUnits: ["jawal", "kg"], priority: 2, icon: "🌽" },
  { slug: "groundnuts", nameAr: "فول سوداني", nameEn: "Groundnuts", defaultUnit: "jawal", altUnits: ["quintar", "kg"], priority: 3, icon: "🥜" },
  { slug: "millet", nameAr: "دخن", nameEn: "Millet", defaultUnit: "quintar", altUnits: ["jawal", "kg"], priority: 7, icon: "🌾" },

  // Vegetables (often by crate/kg)
  { slug: "onions", nameAr: "بصل", nameEn: "Onions", defaultUnit: "crate", altUnits: ["kg", "ton"], priority: 4, icon: "🧅" },
  { slug: "tomatoes", nameAr: "طماطم", nameEn: "Tomatoes", defaultUnit: "crate", altUnits: ["kg"], priority: 10, icon: "🍅" },
  { slug: "potatoes", nameAr: "بطاطس", nameEn: "Potatoes", defaultUnit: "crate", altUnits: ["kg"], priority: 11, icon: "🥔" },

  // Cash crops / others
  { slug: "cotton", nameAr: "قطن", nameEn: "Cotton", defaultUnit: "quintar", altUnits: ["kg"], priority: 6, icon: "☁️" },
  { slug: "wheat", nameAr: "قمح", nameEn: "Wheat", defaultUnit: "quintar", altUnits: ["jawal", "kg"], priority: 9, icon: "🌾" },
  { slug: "gum_arabic", nameAr: "صمغ عربي", nameEn: "Gum Arabic", defaultUnit: "kg", altUnits: ["quintar"], priority: 12, icon: "🌳" },

  // Livestock
  { slug: "livestock", nameAr: "مواشي", nameEn: "Livestock", defaultUnit: "head", altUnits: [], priority: 8, icon: "🐄" },

  // Services bucket (farmer-first)
  { slug: "farm_services", nameAr: "خدمات زراعية", nameEn: "Farm Services", defaultUnit: "service", altUnits: [], priority: 5, icon: "🚜" },
];

// Units labels (AR/EN) for UI
export const UNIT_LABELS = {
  ar: {
    jawal: "جوال",
    quintar: "قنطار",
    kg: "كيلو",
    ton: "طن",
    crate: "قِفّة / صندوق",
    head: "رأس",
    service: "خدمة"
  },
  en: {
    jawal: "Jawal",
    quintar: "Quintar",
    kg: "kg",
    ton: "ton",
    crate: "crate",
    head: "head",
    service: "service"
  },
};

// Helper to get crop by slug
export const getCropBySlug = (slug) => {
  return SUDAN_CROPS.find(c => c.slug === slug) || null;
};

// Helper to get unit label
export const getUnitLabel = (unit, lang = 'en') => {
  return UNIT_LABELS[lang]?.[unit] || unit;
};

// Get crops sorted by priority
export const getCropsByPriority = () => {
  return [...SUDAN_CROPS].sort((a, b) => a.priority - b.priority);
};
